import React, { useRef, useState } from 'react';
import Close from '../../../../Assets/Modals/closeIcon.svg';
import { useDispatch, useSelector } from 'react-redux';
import { closeModal, setOrderStatus } from '../../../../Features/orderDetailsSlice';
import { useOutsideClickHandler } from '../../../../Hooks/useOutsideClick';
import { showToast } from '../../../../Components/Toaster/Toaster';
import { getOrderStatusById, updateOrder } from '../../../../lib/utils/apiCalls';

function CancelOrderForm() {
    const dispatch = useDispatch();
    const wrapperRef = useRef(null);

    useOutsideClickHandler(wrapperRef, () => {
        dispatch(closeModal());
    });

    const [reason, setReason] = useState('');

    const handleButtonClick = () => {
        dispatch(closeModal());
    };

    const orderDetails = useSelector((state) => state.orderDetails.orderDetails.orderDetails);

    const handleCancelOrderButton = async () => {
        if(reason.length) {
            const callData = {
                id: orderDetails.orderId,
                orderStatus: 'CANCELLED',
                returnAccepted: true,
                exchangeAccepted: false,
                reason: reason
            }

            try {
                const response = await updateOrder(callData);
                if(response) {
                    const response = await getOrderStatusById(orderDetails.orderId);
                    dispatch(setOrderStatus(response));
                    showToast('Order Cancelled!', 'success');
                    dispatch(closeModal());
                }
                else {
                    showToast('Error cancelling order!', 'error');
                }
            }
            catch(err) {
                showToast('Error cancelling order!', 'error');
            }
        }
        else {
            showToast('Write a reason before cancelling!', 'warning');
        }
    }

    const handleChange = (e) => {
        setReason(e.target.value);
    }

    return (
        <div ref={wrapperRef} className="w-[45%] h-[32rem] bg-[#FFFFFF] rounded-xl p-6 flex flex-col gap-3 shadow-[0px_0px_12px_0px_#0000003D]">
            <div className="flex items-center justify-between">
                <h1 className='font-semibold text-2xl text-[#121212]'>Cancel Order</h1>

                <button onClick={handleButtonClick}>
                    <img src={Close} alt="Close Modal" />
                </button>
            </div>

            <form className="flex flex-col h-full gap-6">
                <div className="flex flex-col gap-3 h-full">
                    <label className='m-0 font-medium text-base text-[#000000]' htmlFor="name-input">
                        Are you sure you want to cancel this order? Please provide a reason for cancellation to inform the shopper. This helps maintain trust and transparency.
                    </label>

                    <div className="h-full bg-[#F5F5F5] px-3 py-4 rounded-lg border border-[#EAEAEA] flex items-center justify-center">
                        <textarea 
                            placeholder='Enter product description' 
                            className='size-full bg-transparent outline-none border-none text-sm font-medium placeholder:text-[#666666]' 
                            type="text" 
                            value={reason} 
                            onChange={handleChange} 
                        />
                    </div>
                </div>

                <button onClick={handleCancelOrderButton} className='whitespace-nowrap px-4 py-2 rounded font-semibold text-base text-center bg-[#EF4444] text-[#FFFFFF]' type='button'>
                    Send and Cancel Order
                </button>
            </form>
        </div>
    );
}

export default CancelOrderForm;
